import type { ReportColumn, ResultCell } from "../../../api/portalReportsApi";
import { columnTotal, formatCell, formatValue } from "./formatCell";

/**
 * Stat tiles: one tile per visible column. With a single row the tile shows
 * that value; with several rows the column's total (default sum) is shown.
 */
export function StatsSection({ columns, colIndex, rows }: { columns: ReportColumn[]; colIndex: Record<string, number>; rows: ResultCell[][] }) {
  const visible = columns.filter((c) => c.visible !== false && colIndex[c.name] != null);
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 10 }}>
      {visible.map((c) => {
        let text: string;
        if (rows.length === 1) text = formatCell(rows[0][colIndex[c.name]], c);
        else if (rows.length === 0) text = "—";
        else {
          const t = columnTotal(rows.map((r) => r[colIndex[c.name]]), c.total && c.total !== "none" ? c.total : "sum");
          text = t == null ? "—" : formatValue(t, c.format === "text" ? "decimal" : c.format, c.decimals);
        }
        return (
          <article key={c.name} style={{ margin: 0, padding: "10px 14px", borderRadius: 12, border: "1px solid var(--portal-primary-faint)", display: "grid", gap: 2, minWidth: 0 }}>
            <header style={{ color: "var(--portal-muted)", fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.05em", fontWeight: 600 }}>
              {c.label || c.name}
            </header>
            <div style={{ fontSize: "1.5rem", fontWeight: 700, lineHeight: 1.2, overflow: "hidden", textOverflow: "ellipsis" }}>{text}</div>
          </article>
        );
      })}
      {visible.length === 0 && <div style={{ color: "var(--portal-muted)" }}>No columns selected.</div>}
    </div>
  );
}
